import * as action from "../../utils/Actions";

export function showErrorToast(message){
  return (dispatch)=>
    dispatch({
      type: action.SHOW_ERROR_TOAST,
      meta: {message: message}
    });
}

export function resetErrorToast(){
    return (dispatch)=>
    dispatch({
      type: action.RESET_TOAST
    });
}